import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Subject } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class RestapiService {

  route: string = 'https://educacion.wwfbolivia.org/restapi/public';
  //route: string = 'https://wwfedu-admin.aknatechnologies.com/restapi/public';
  //route: string = 'http://localhost:8000';

  categories: any;
  cities: any;
  menu: any;
  social: any;

  constructor(
    private _sanitizer: DomSanitizer,
    public http: HttpClient
  ) {
    this.getdata('websocial', { per_page: 1000 })
      .subscribe(res => {
        if (res.status === true) {
          this.social = {};
          res.result.data.forEach(el => {
            this.social[el.name] = el.url;
          });
        }
      });

  }

  getdata(model: string, params: object, auth?: boolean) {
    const httpOptions = auth === true ? { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem("tk") }) } : {};
    //params['tk'] = auth === true ? localStorage.getItem("tk") : '';
    console.log('API getdata: ' + model, params);
    return this.http.post<any>(this.route + "/api/" + model + "/getdata", params, httpOptions);
  }

  store(model: string, params: object, auth?: boolean) {
    const httpOptions = auth === true ? { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem("tk") }) } : {};
    //params['tk'] = auth === true ? localStorage.getItem("tk") : '';
    console.log('API store: ' + model, params, auth);
    return this.http.post<any>(this.route + "/api/" + model + "/store", params, httpOptions);
  }

  update(model: string, params: object, id: number, auth?: boolean) {
    const httpOptions = auth === true ? { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem("tk") }) } : {};
    //params['tk'] = auth === true ? localStorage.getItem("tk") : '';
    console.log('API update: ' + model, params, id, auth);
    return this.http.post<any>(this.route + "/api/" + model + "/update/" + id, params, httpOptions);
  }

  delete(model: string, params: object, id: number, auth?: boolean) {
    const httpOptions = auth === true ? { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem("tk") }) } : {};
    //params['tk'] = auth === true ? localStorage.getItem("tk") : '';
    console.log('API delete: ' + model, params, id, auth);
    return this.http.post<any>(this.route + "/api/" + model + "/update/" + id, params, httpOptions);
  }

  getAppContent(params: object, auth?: boolean) {
    const httpOptions = auth === true ? { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem("tk") }) } : {};
    console.log('App Content: ', params);
    return this.http.post<any>(this.route + "/api/app/webcontent", params, httpOptions);
  }

  getVideoIframe(url) {
    var video, results;
    if (url === null) {
      return '';
    }
    results = url.match('[\\?&]v=([^&#]*)');
    video = (results === null) ? url : results[1];
    return this._sanitizer.bypassSecurityTrustResourceUrl('https://www.youtube.com/embed/' + video);
  }

  getImageUrl(file?: string) {
    if (!file) {
      return '/assets/wwf-og.jpg'
    }
    else {
      return encodeURI(this.route + file);
    }
  }


  //new Date(el.created_at)
  isNewOnWeb(date1: any) {
    let date2: any = new Date();
    let diffTime = Math.abs(date2 - date1);
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    console.log(diffDays + " days");
    return (diffDays <= 15);
  }

}
